// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"023cbd97","453":"26791ccb","455":"2b5f1edb","977":"3b3baf53"}[chunkId] + ".chunk.js";
};